module.exports = __webpack_public_path__ + "3ec073a40a06f74cc128202f4118c464.png";